/**
 * This is the app's name parsed by lambda@Edge
 *  eg, express.grab.com/track
 *
 * It is also used for various webpack/deployment values
 * so its kept pure here (no slashes) with the intention
 * that slashes be added as needed
 */
export const APP_BASE_URL_NAME = `track`;

export const LOGIN_PATH = '/login';
export const MAIN_VIEW_PATH = '/main';
export const FAQ_PATH = '/faq';
